import { AppSidebarLayout } from "../layouts";
import { AppServicesByOrg } from "../shared";

export function ServicesPage() {
  return (
    <AppSidebarLayout>
      <AppServicesByOrg />
    </AppSidebarLayout>
  );
}
